// An affiliate's link carries ?ref=CODE. The code is kept in the browser for 30 days so sign-up can fill it in.

const KEY = 'ibigdo.referral';
const DAYS = 30;

/** Remembers a ?ref= code from the address, if there is one. */
export function captureReferral() {
  try {
    const code = new URLSearchParams(window.location.search).get('ref');
    if (code && /^[A-Za-z0-9]{4,12}$/.test(code.trim())) {
      localStorage.setItem(KEY, JSON.stringify({ code: code.trim().toUpperCase(), at: Date.now() }));
    }
  } catch (e) {
    // The code can still be typed
  }
}

/** The remembered code, or '' once it is older than 30 days. */
export function savedReferral() {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (saved && saved.code && Date.now() - saved.at < DAYS * 24 * 3600 * 1000) return saved.code;
    localStorage.removeItem(KEY);
  } catch (e) {
    // nothing remembered
  }
  return '';
}

export function forgetReferral() {
  try { localStorage.removeItem(KEY); } catch (e) { /* nothing to forget */ }
}
